// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";

require("./AboutPage.css");

var cahya = require("../assets/cahya.png");

function AboutPage(Props) {
  return React.createElement("div", {
              className: "about-page single-page"
            }, React.createElement("div", {
                  className: "content"
                }, React.createElement("h1", undefined, "About"), React.createElement("h3", undefined, "Omonib by PT Cahaya Sukses Sejahtera"), React.createElement("img", {
                      alt: "Cahya",
                      src: cahya
                    }), React.createElement("h4", undefined, "Cahya \"Sukses\" Nugraha"), React.createElement("h5", undefined, "CEO, CTO, C*O, & Founder"), React.createElement("p", undefined, "\"Saya mulai membangun Omonib saat saya bisa membeli 1000 kontrak dalam\n        sehari tanpa keluar rumah. Kini giliran anda yang melakukannya.\"")));
}

var make = AboutPage;

export {
  cahya ,
  make ,
  
}
/*  Not a pure module */
